(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.headerCoords = {};
    this.calcHeaderCoords()

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	calcHeaderCoords() {
    const clientRect = this.getBoundingClientRect();
    const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.headerCoords.bottom = pageYOffset + clientRect.bottom;
    this.headerCoords.top = pageYOffset + clientRect.top;
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					this.header.classList.add('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					this.header.classList.remove('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerCoords.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.spinnerIcon = this.querySelector('.cart__note-loading');
      this.successIcon = this.querySelector('.cart__note-success');
      this.textarea = this.querySelector('textarea');
      this.cartButtons = document.querySelector('.cart__ctas');

      this.textarea.addEventListener(
        'input',
        debounce((event) => {
          this.spinnerIcon.style.display = 'block';
          this.successIcon.style.display = 'none';
          this.cartButtons.style.pointerEvents = 'none';
          this.cartButtons.style.opacity = '0.7';

          const body = JSON.stringify({ note: event.target.value });

          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then((data) => {
              this.successIcon.style.display = 'block';

              setTimeout(() => {
                this.successIcon.style.display = 'none';
              }, 2000);
            })
            .catch((error) => {
              console.error('There was a problem with the fetch operation:', error);
            })
            .finally(() => {
              this.spinnerIcon.style.display = 'none';
              this.cartButtons.removeAttribute('style');
            });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section3-fullwidth-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.st3Ready === 'true') return;
      root.dataset.st3Ready = 'true';

      const slides = Array.from(root.querySelectorAll('[data-st3-slide]'));
      const copies = Array.from(root.querySelectorAll('[data-st3-copy]'));
      const dots = Array.from(root.querySelectorAll('[data-st3-dot]'));
      const previousButton = root.querySelector('[data-st3-prev]');
      const nextButton = root.querySelector('[data-st3-next]');
      const stage = root.querySelector('[data-st3-stage]');
      let activeIndex = 0;
      let pointerStart = null;
      let dragged = false;

      if (!slides.length) return;

      const updateVideos = () => {
        slides.forEach((slide, index) => {
          slide.querySelectorAll('video').forEach((video) => {
            video.muted = true;
            video.loop = true;
            video.playsInline = true;

            if (index === activeIndex) {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const setActive = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        const previousIndex = activeIndex - 1;
        const nextIndex = activeIndex + 1;

        slides.forEach((slide, slideIndex) => {
          const wasPrevious = slide.classList.contains('is-prev');
          const wasNext = slide.classList.contains('is-next');
          const isActive = slideIndex === activeIndex;
          const isPrevious = activeIndex > 0 && slideIndex === previousIndex;
          const isNext = activeIndex < slides.length - 1 && slideIndex === nextIndex;
          const crossesBehind = wasPrevious && isNext || wasNext && isPrevious;

          if (crossesBehind) slide.classList.add('is-no-transition');
          slide.classList.toggle('is-active', isActive);
          slide.classList.toggle('is-prev', isPrevious);
          slide.classList.toggle('is-next', isNext);
          slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');

          if (crossesBehind) {
            requestAnimationFrame(() => slide.classList.remove('is-no-transition'));
          }
        });

        copies.forEach((copy, copyIndex) => {
          const isActive = copyIndex === activeIndex;
          copy.classList.toggle('is-active', isActive);
          copy.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        updateVideos();
      };

      previousButton?.addEventListener('click', () => setActive(activeIndex - 1));
      nextButton?.addEventListener('click', () => setActive(activeIndex + 1));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => setActive(Number(dot.dataset.slideIndex)));
      });

      slides.forEach((slide, slideIndex) => {
        slide.addEventListener('click', () => {
          if (!dragged && slideIndex !== activeIndex) setActive(slideIndex);
          dragged = false;
        });
      });

      stage?.addEventListener('pointerdown', (event) => {
        pointerStart = event.clientX;
        dragged = false;
      });

      stage?.addEventListener('pointermove', (event) => {
        if (pointerStart === null) return;
        dragged = Math.abs(event.clientX - pointerStart) > 8;
      });

      stage?.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 45) return;
        setActive(activeIndex + (distance < 0 ? 1 : -1));
      });

      stage?.addEventListener('pointercancel', () => {
        pointerStart = null;
        dragged = false;
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
        if (event.key === 'ArrowRight') setActive(activeIndex + 1);
      });

      setActive(0);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-st3-showcase]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st3-fgm-lab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const visitorId = () => {
      const key = 'fgm_download_visitor_id';
      try {
        let value = localStorage.getItem(key);
        if (!value) {
          value = crypto.randomUUID();
          localStorage.setItem(key, value);
        }
        return value;
      } catch (error) {
        return crypto.randomUUID();
      }
    };

    const endpoint = (base, path) => `${base.replace(/\/$/, '')}${path}`;

    const initSection = (root) => {
      if (!root || root.dataset.fgmInitialized === 'true') return;
      root.dataset.fgmInitialized = 'true';
      const workerBase = root.dataset.workerBase.trim();
      const tabs = [...root.querySelectorAll('[data-fgm-tab]')];
      const panels = [...root.querySelectorAll('[data-fgm-panel]')];

      const activateTab = (tab) => {
        if (!tab) return;
        const target = tab.dataset.fgmTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.fgmPanel !== target;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab));
      });

      const formResult = root.querySelector('[data-fgm-form-result]');
      if (formResult) {
        activateTab(tabs.find((tab) => tab.dataset.fgmTab === 'request'));
        requestAnimationFrame(() => formResult.focus({ preventScroll: true }));
      }

      const filters = [...root.querySelectorAll('[data-fgm-filter]')];
      const cards = [...root.querySelectorAll('[data-fgm-card]')];
      const grid = root.querySelector('[data-fgm-grid]');
      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          const category = filter.dataset.fgmFilter;
          filters.forEach((item) => {
            const active = item === filter;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          cards.forEach((card) => {
            card.hidden = category !== 'all' && card.dataset.category !== category;
          });
          grid?.scrollTo({ left: 0, behavior: 'smooth' });
        });
      });

      if (workerBase) {
        fetch(endpoint(workerBase, '/api/fgm/counts'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then((response) => {
            if (!response.ok) throw new Error('Count request failed');
            return response.json();
          })
          .then((payload) => {
            const counts = payload.data || payload;
            cards.forEach((card) => {
              const countNode = card.querySelector('[data-fgm-count]');
              if (!countNode) return;
              const count = counts[card.dataset.guideId]?.total || 0;
              countNode.textContent = Number(count).toLocaleString();
            });
          })
          .catch(() => {});
      }

      root.querySelectorAll('[data-fgm-download]').forEach((link) => {
        link.addEventListener('click', () => {
          const payload = {
            guideId: link.dataset.guideId,
            guideName: link.dataset.guideName,
            fileType: link.dataset.fileType,
            visitorId: visitorId()
          };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'fgm_download',
            guide_id: payload.guideId,
            guide_name: payload.guideName,
            file_type: payload.fileType
          });
          if (!workerBase) return;
          const body = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
          const url = endpoint(workerBase, '/api/fgm/download');
          if (!navigator.sendBeacon(url, body)) {
            fetch(url, { method: 'POST', body, keepalive: true }).catch(() => {});
          }
        });
      });

    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-fgm-section]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
